import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Badge, Input, Modal, Tooltip } from "antd";
import dayjs from "dayjs";

import { errEnum, PAGE_LENGTH } from "../../config";
import popupImg from "../../assets/images/free-user-login-prompt.jpg.jpeg";
import emailSync from "../../assets/images/email-setup/email-sync.svg";
import TrialModal from "../../common/TrialModal";
import {
  getExecutiveEmployeeList,
  savePaginationValues,
  saveAdvancedSelectedFilters,
  selectedRow,
  saveSearchAction,
  createGroupLeadTag, //api/client-leads
  setPageLayout,
  emptyErrorObj,
} from "../../actionCreator/leadListingActionCreater";
import { getUserInfo } from "../../utils/utils";
import LeadTableView from "./LeadTableView";
import LeadKanbanView from "./LeadKanbanView";
import CalenderModal from "./CalenderModal";
import { colorArray } from "../../constant/profileBgcolors";
import { useExport } from "./hooks/useExport";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";
import EmailForm from "../../common/EmailForm";
import UpdateLead from "./UpdateLead";
import CreateNewLead from "./CreateNewLead";

const LeadContent = () => {
  const { onExport } = useExport();
  const { showAlert } = useAlert();
  const [showCal, setShowCal] = useState(false);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });
  const leadStatusListing = useSelector(
    (state) => state.leadListingReducer.leadStatusList
  );
  const errObj = useSelector((state) => state.leadListingReducer.errObj);
  const unreadNotifications = useSelector(
    (state) => state.LeadDetailsReducer.unreadNotifications
  );

  const showStatusName = (status) => {
    let st = "";
    for (let i = 0; i < leadStatusListing.length; i++) {
      if (status == leadStatusListing[i].id) {
        st = leadStatusListing[i].text;
        break;
      }
    }
    return st;
  };

  const getCompanyDetails = (id, name) => {
    let cname = name.replaceAll(" ", "-", name);
    navigate(`/company-summary/${id}/${cname}`);
  };

  const columns = [
    {
      title: <div className="companyname">Lead Name</div>,
      dataIndex: "name",
      fixed: "left",
      render: (record, row, index) => {
        return (
          <div className="namecol">
            <div
              className="logo"
              style={{
                textTransform: "uppercase",
                backgroundColor: colorArray[index],
              }}
              onClick={() => getDetails(row.key)}
            >
              {record?.firstname?.[0]}
              {record?.lastname?.[0]}
            </div>
            <div
              className="visible-on-hover d-flex align-items-center justify-content-between"
              style={{ width: "80%" }}
            >
              <span className="cname" onClick={() => getDetails(row.key)}>
                {/* {record?.fullname} */}
                {record?.fullname
                  ? record.fullname
                  : record.firstname + " " + record.lastname}
              </span>
              <UpdateLead
                title="Lead Name"
                fieldName="fullname"
                defaultValue={{
                  fullname: record?.fullname
                    ? record.fullname
                    : record.firstname + " " + record.lastname,
                  firstname: record.firstname,
                  lastname: record.lastname,
                }}
                id={row?.key}
                callback={() => onPageChange(1, paginationValue.end)}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      className: "phone",
      render: (record, row) => {
        return (
          <span
            className="visible-on-hover d-flex align-items-center justify-content-between"
            style={{ width: "80%" }}
          >
            <span>{record}</span>
            <UpdateLead
              title="Phone Number"
              fieldName="phoneNo"
              defaultValue={record}
              id={row?.key}
              callback={() => onPageChange(1, paginationValue.end)}
            />
          </span>
        );
      },
    },
    {
      title: "Company",
      dataIndex: "companyName",
      render: (record, row) => {
        return (
          <div className="namecol">
            <span
              className="visible-on-hover d-flex align-items-center justify-content-between"
              style={{ width: "80%" }}
            >
              <span
                className="cname"
                onClick={() =>
                  row?.companyId
                    ? getCompanyDetails(row?.companyId, row?.companyName)
                    : getDetails(row?.key)
                }
              >
                {row?.companyName}
              </span>
              <UpdateLead
                title="Company Name"
                fieldName="companyName"
                defaultValue={record}
                id={row?.key}
                callback={() => onPageChange(1, paginationValue.end)}
              />
            </span>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (record, row) => {
        return (
          <div className="namecol">
            <span
              className="visible-on-hover d-flex align-items-center justify-content-between"
              style={{ width: "80%" }}
            >
              <span>{row?.status ? showStatusName(row?.status) : ""}</span>
              <UpdateLead
                title="Status"
                fieldName="status"
                defaultValue={{
                  status: record,
                  lostReason: row?.executiveData?.lostReason,
                  comments: row?.executiveData?.comments,
                }}
                id={row?.key}
                callback={() => onPageChange(1, paginationValue.end)}
              />
            </span>
          </div>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      className: "email",
      width: 150,
      render: (record, row) => {
        const notiClientIds = unreadNotifications?.map((d) => d?.clientLeadId);
        const isUnread = notiClientIds.includes(row?.key);
        return (
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ gap: 10 }}
          >
            <Tooltip title={record}>
              <span>
                {record?.length > 12 ? `${record.substring(0, 10)}...` : record}
              </span>
            </Tooltip>
            <div className="email-grp-btn">
              <div
                style={{
                  height: "25px",
                  width: "25px",
                  padding: "5px",
                  maxWidth: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="cursor-pointer"
                onClick={() => navigate(`/lead-details/${row?.key}?type=email`)}
              >
                <Badge dot={isUnread} offset={[-1, 5]}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="10.5"
                    viewBox="0 0 19.967 14.975"
                    fill="#707070"
                  >
                    <g transform="translate(-10.66 -31.98)">
                      <path
                        d="M29.379,31.98H11.908a1.248,1.248,0,0,0-1.248,1.248V45.707a1.248,1.248,0,0,0,1.248,1.248H29.379a1.248,1.248,0,0,0,1.248-1.248V33.228A1.248,1.248,0,0,0,29.379,31.98Zm-.961,13.727H12.944l4.368-4.517-.9-.867-4.5,4.661V34.176l7.756,7.718a1.248,1.248,0,0,0,1.76,0l7.955-7.912V44.9L24.786,40.31l-.88.88ZM12.725,33.228H28.368l-7.824,7.781Z"
                        fill="#707070"
                      />
                    </g>
                  </svg>
                </Badge>
              </div>
              {isEmailSetupView && (
                <EmailForm
                  recipientEmail={record}
                  empId={row?.name?.employeeId}
                >
                  <img
                    src={emailSync}
                    alt=""
                    style={{
                      borderLeft: "0.20000000298023224px solid #707070",
                      height: "25px",
                      width: "25px",
                      padding: "5px",
                      maxWidth: "25px",
                    }}
                  />
                </EmailForm>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: "Updated Date",
      dataIndex: "lastModifiedDate",
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated: isLoggedIn, isEmailSetupView } =
    useContext(AuthContext);
  const [executiveEmployeeList, setExecutiveEmployeeList] = useState();

  const [showModal, setShowModal] = useState(false);
  const [showTagModal, setShowTagModal] = useState(false);
  const [showAddLeadModal, setShowAddLeadModal] = useState(false);

  const [tagValues, setTagValues] = useState({
    tagname: "",
    description: "",
    tagError: "",
  });
  const [searchValues, setSearchValues] = useState({
    tagname: "",
    description: "",
    tagError: "",
  });
  const companyFilterList = useSelector((state) => state.leadListingReducer);
  const companySelectedFilterList = useSelector(
    (state) => state.leadListingReducer.selectedFilters
  );
  const loading = useSelector((state) => state.CommonReducer.loading);
  const paginationValue = useSelector(
    (state) => state.leadListingReducer.paginationValue
  );
  const selectedRecords = useSelector(
    (state) => state.leadListingReducer.selectedRecords
  );

  const selectedPageLayout = useSelector(
    (state) => state.leadListingReducer.leadPageLayout
  );

  const renderSocialLinks = (socialLinks) => {
    return socialLinks?.map((link, index) => {
      if (link?.name === "facebook") {
        return (
          <Link key={index} to={link?.proifileUrl} target="_blank">
            <i className="lab fs-20 facebook lab la-facebook"></i>
          </Link>
        );
      } else if (link?.name === "Linkedin") {
        return (
          <Link to={link?.proifileUrl} target="_blank">
            <i className="lab fs-20 linkedin  lab la-linkedin"></i>
          </Link>
        );
      } else if (link?.name === "twitter") {
        return (
          <Link to={link?.proifileUrl} target="_blank">
            <i className="lab fs-20  twitter la la-twitter-square"></i>
          </Link>
        );
      }
    });
  };

  useEffect(() => {
    let data = [];
    companyFilterList?.executiveEmployeeList?.forEach((record) => {
      data = [
        ...data,
        {
          key: record.id,
          executiveData: record,
          name: record,
          companyName: record?.companyName,
          companyId: record?.companyId,
          location: `${record?.city ? record?.city + "," : ""} ${
            record?.state ? record?.state : ""
          }`,
          email: record?.emailId,
          phone: record?.phoneNo,
          mobile: record.phoneNo,
          status: record?.status,
          social: renderSocialLinks(record?.socialLinks),
          notes: "",
          lastModifiedDate: record?.lastModifiedDate
            ? dayjs(record?.lastModifiedDate).format("DD-MM-YYYY")
            : "",
        },
      ];
    });
    setExecutiveEmployeeList(data);
  }, [companyFilterList]);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      if (!selected) {
        const filteredRecords = selectedRecords?.filter(
          (d) => d !== record.key
        );
        dispatch(selectedRow(filteredRecords));
      } else {
        dispatch(selectedRow([...selectedRecords, record.key]));
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const keys = changeRows?.map((d) => d.key);
      if (!selected) {
        const filteredRecords = selectedRecords?.filter(
          (d) => !keys.includes(d)
        );
        dispatch(selectedRow(filteredRecords));
      } else {
        dispatch(selectedRow([...selectedRecords, ...keys]));
      }
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
    selectedRowKeys: selectedRecords,
  };

  const checkLoginStatus = () => {
    if (isLoggedIn) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  };

  const onPageChange = (page, pageSize) => {
    const pageValues = {
      start: page - 1,
      end: pageSize,
    };
    dispatch(savePaginationValues(pageValues));
    dispatch(getExecutiveEmployeeList(companySelectedFilterList, pageValues));
  };

  const getDetails = (id) => {
    navigate(`/lead-details/${id}`);
  };

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
  };

  const onConfrim = () => {
    if (!searchValues.tagname) {
      setSearchValues({
        ...searchValues,
        tagError: "error",
      });
    } else {
      const { id, email, login } = getUserInfo();
      const payload = {
        accountId: login,
        dataDump: JSON.stringify(companySelectedFilterList),
        fullName: searchValues.tagname,
        emailId: email,
        source: "Executive",
        userId: id,
      };
      dispatch(saveSearchAction(payload));
      setShowModal(false);
    }
  };

  const onInputChange = (e) => {
    setSearchValues({
      ...searchValues,
      [e.target.name]: e.target.value,
    });
  };

  const redirectToSignup = () => {
    setShowModal(false);
    setOpenModal(false);
    navigate("/signup");
  };

  const tagPage = () => {
    checkLoginStatus();
    if (isLoggedIn) {
      if (selectedRecords.length) {
        setShowTagModal(true);
      } else {
        showAlert("warning", "please select record.");
      }
    }
  };

  const printPage = () => {
    checkLoginStatus();
    if (isLoggedIn) {
      window.print();
    }
  };

  const closeTagModal = () => {
    setShowTagModal(false);
  };

  const onTagConfrim = () => {
    if (!tagValues.tagname) {
      setTagValues({
        ...tagValues,
        tagError: "error",
      });
    } else {
      const { id } = getUserInfo();
      let payload = [];
      for (let i = 0; i < selectedRecords.length; i++) {
        payload = [
          ...payload,
          {
            employee: selectedRecords[i]?.name,
            text: tagValues.tagname,
            userId: id,
          },
        ];
      }
      dispatch(createGroupLeadTag(payload));
      setShowTagModal(false);
    }
  };

  const onTagInputChange = (e) => {
    setTagValues({
      ...tagValues,
      [e.target.name]: e.target.value,
    });
  };

  const checkPageLayout = (page) => {
    dispatch(setPageLayout({ activePage: page }));
    const pageValues = {
      start: 0,
      end: PAGE_LENGTH,
    };
    const payload = {
      ...companySelectedFilterList,
      selectedPageLayout: page,
    };
    dispatch(saveAdvancedSelectedFilters(payload));
    dispatch(getExecutiveEmployeeList(payload, pageValues));
  };

  useEffect(() => {
    if (selectedPageLayout?.activePage === 2) {
      const pageValues = {
        start: 0,
        end: PAGE_LENGTH,
      };
      const payload = {
        ...companySelectedFilterList,
        selectedPageLayout: selectedPageLayout?.activePage,
      };
      dispatch(getExecutiveEmployeeList(payload, pageValues));
    }
  }, [selectedPageLayout, dispatch, companySelectedFilterList]);

  const calendarShow = () => {
    navigate(`/leads-timeline`);
  };

  const closeCalenderModal = () => {
    setShowCal(false);
  };
  const handleAddLeadsForm = () => {
    setShowAddLeadModal(true);
  };

  return (
    <>
      {selectedPageLayout?.activePage === 2 ? (
        <LeadKanbanView
          calendarShow={calendarShow}
          checkPageLayout={checkPageLayout}
          loading={loading}
          rowSelection={rowSelection}
          getDetails={getDetails}
          executiveEmployeeList={executiveEmployeeList}
          paginationValue={paginationValue}
          companyFilterList={companyFilterList}
          onPageChange={onPageChange}
        />
      ) : (
        <LeadTableView
          calendarShow={calendarShow}
          checkPageLayout={checkPageLayout}
          tagPage={tagPage}
          downloadExcel={() => {
            checkLoginStatus();
            onExport(selectedRecords, "exl");
          }}
          downloadPDF={() => {
            checkLoginStatus();
            onExport(selectedRecords, "pdf");
          }}
          printPage={printPage}
          loading={loading}
          rowSelection={rowSelection}
          columns={columns}
          executiveEmployeeList={executiveEmployeeList}
          paginationValue={paginationValue}
          companyFilterList={companyFilterList}
          onPageChange={onPageChange}
          handleAddLeadsForm={handleAddLeadsForm}
        />
      )}

      {errObj[errEnum.LEAD_EXECUTIVE_DOWNLOAD_ERROR] && (
        <TrialModal
          openModal={!!errObj[errEnum.LEAD_EXECUTIVE_DOWNLOAD_ERROR]}
          closeModal={() => dispatch(emptyErrorObj())}
          buttonText="OK"
          modalBody={
            <div id="small-dialog2">
              {errObj[errEnum.LEAD_EXECUTIVE_DOWNLOAD_ERROR]
                ? errObj[errEnum.LEAD_EXECUTIVE_DOWNLOAD_ERROR].message
                : "Unable to complete the action. Please try again later."}
            </div>
          }
          modalWidth="400px"
        />
      )}

      {showAddLeadModal && (
        <CreateNewLead
          openModal={true}
          setShowAddLeadModal={setShowAddLeadModal}
        />
      )}
      {showTagModal && isLoggedIn ? (
        <Modal
          title="Tag Lead"
          width={"400px"}
          closable={true}
          open={showTagModal}
          onCancel={closeTagModal}
          onOk={onTagConfrim}
        >
          <div className="pop-up errorformcontainer ">
            <div className="form">
              <div className="formcol1">
                <label>Tag Name</label>
              </div>
              <div className="formcol2">
                <Input
                  name="tagname"
                  status={tagValues?.tagError}
                  value={tagValues.tagname}
                  placeholder="Name"
                  onChange={onTagInputChange}
                />
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}

      {showModal ? (
        isLoggedIn ? (
          <Modal
            title="Save Search"
            width={"400px"}
            closable={true}
            open={showModal}
            onCancel={closeModal}
            onOk={onConfrim}
          >
            <div className="pop-up errorformcontainer ">
              <div className="form">
                <div className="formcol1">
                  <label>Search Name</label>
                </div>
                <div className="formcol2">
                  <Input
                    name="tagname"
                    status={searchValues?.tagError}
                    value={searchValues.tagname}
                    placeholder="Name"
                    onChange={onInputChange}
                  />
                </div>
              </div>
            </div>
          </Modal>
        ) : (
          <TrialModal
            openModal={showModal}
            closeModal={closeModal}
            redirectToSignup={redirectToSignup}
            buttonText="Start Free Trial"
            redirect={true}
            modalBody={
              <div id="small-dialog2">
                <div align="center">
                  <img src={popupImg} alt="" />
                </div>
                <p style={{ color: "#0000FF" }}>
                  Get 10 free verified contacts with a BeyondLeadz Pro trial
                </p>
                <p>
                  BeyondLeadz Pro customers close deals faster thanks to
                  relevant
                </p>
              </div>
            }
            modalWidth="400px"
          />
        )
      ) : (
        ""
      )}

      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          // buttonText="Start Free Trial"
          buttonText="SUBSCRIBE NOW!"
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={popupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                PLEASE SUBSCRIBE TO VIEW ALL DETAILS
              </p>
            </div>
          }
          modalWidth="400px"
        />
      )}

      {showCal && (
        <Modal
          title="Calendar"
          width={"800px"}
          closable={true}
          open={showCal}
          onCancel={closeCalenderModal}
          // onOk={onConfrimCalenderModal}
          footer={[]}
        >
          <CalenderModal />
        </Modal>
      )}
    </>
  );
};

export default LeadContent;
